import React from "react";
import { Grid } from "@mui/material";
import TabSwitch from "components/tab-switch";
import { Action } from "pages/dashboard/interests-profile/components/reason-modal";
import { ActionKey, tabActions, tabsData } from "./helpers";

type Props = {
  action: Action | undefined;
  switches: Record<ActionKey, boolean>;
  tabErrors: Record<ActionKey, boolean>;
  tabErrorTooltips: Record<ActionKey, string>;
  onSwitchToggle: (key: ActionKey) => void;
  onTabClick: (key: ActionKey) => void;
}

const ActionsTabs: React.FC<Props> = ({
  action,
  switches,
  tabErrors,
  tabErrorTooltips,
  onSwitchToggle,
  onTabClick,
}) => (
  <>
    {tabsData.map((tab) => (
      <Grid key={tab.key} size={{ md: 3, sm: 6 }}>
        <TabSwitch
          id={`${tab.key}-switch`}
          tabIsActive={action === tabActions[tab.key]}
          switchIsOn={switches[tab.key]}
          onSwitchClick={() => onSwitchToggle(tab.key)}
          onTabClick={() => onTabClick(tab.key)}
          label={tab.label}
          tabHasError={tabErrors[tab.key]}
          tabErrorTooltip={tabErrorTooltips[tab.key]}
        />
      </Grid>
    ))}
  </>
);

export default ActionsTabs;

